export default __webpack_public_path__ + "static/media/Urgent 3.c6edef1e.svg";